module.exports = {"year":"Năm","month":"Tháng","amount":"Số tiền","video":"Video","paid":"Đã trả","yes":"Có","no":"Không","unknown":"Video không được tải"};